import React, { useEffect, useMemo, useState } from "react";
import {
  Typography,
  TextField,
  Box,
  Paper,
  Grid,
  Container,
  Divider,
  debounce,
} from "@mui/material";
import { useDispatch } from "react-redux";

const MemoizedField = React.memo(({ value, onChange, disabled }) => (
  <TextField
    type="number"
    inputProps={{ min: 0, max: 100 }}
    value={value}
    onChange={onChange}
    size="small"
    fullWidth
    sx={{
      width: { sm: "70px", xs: "100%" },
      background: disabled ? "#f0f0f0" : "white",
    }}
    disabled={disabled}
  />
));

const AppraisalFormComponent = ({
  onDataChange,
  questionSectionData,
  getKraKpiAppraisalForm,
}) => {
  const [data, setData] = useState([]);
  const [achievements, setAchievements] = useState({});
  console.log(achievements, "accccccccccc");
  const dispatch = useDispatch();

  console.log(getKraKpiAppraisalForm, "getKraKpiAppraisalForm");
  console.log(questionSectionData, "questionSectionData");
  const [hasChanged, setHasChanged] = useState(false);

  // const handleChange = (kraIndex, kpiIndex, value) => {
  //     const safeValue = Math.max(0, Math.min(100, Number(value)));
  //     const key = `${kraIndex}-${kpiIndex}`;

  //     // update just the raw achievements fast
  //     setAchievements(prev => ({ ...prev, [key]: safeValue }));

  //     setHasChanged(true);

  //     // defer the expensive recalculation
  //     debouncedUpdateQuestions({ ...achievements, [key]: safeValue });
  // };

  const handleChange = (kraIndex, kpiIndex, value) => {
    const safeValue = Math.max(0, Math.min(100, Number(value)));
    const key = `${kraIndex}-${kpiIndex}`;

    setAchievements((prev) => {
      const updated = { ...prev, [key]: safeValue };

      // Pass the correct updated object
      debouncedUpdateQuestions(updated);

      return updated;
    });

    setHasChanged(true);
  };

  const debouncedUpdateQuestions = useMemo(
    () =>
      debounce((updated) => {
        const kraKpiQuestions = [];

        questionSectionData?.forEach((kra, i) => {
          const kraId = `KRA_0${i + 1}`;
          const kpiArray = [];
          let totalAchievement = 0;

          kra.kpis.forEach((kpi, j) => {
            const kpiId = `KPI_0${j + 1}`;
            const fullKpiId = `${kraId}_${kpiId}`;
            const userInput = updated[`${i}-${j}`] || 0;

            const achievement = Number(calculateScore(kpi.weight, userInput));
            totalAchievement += achievement;

            kpiArray.push({
              [fullKpiId]: {
                Parameter: kpi.parameter,
                Weightage: parseFloat(kpi.weight) || 0,
                achievementPercentage: userInput,
                Achievement: achievement,
              },
            });
          });

          kraKpiQuestions.push({
            [kraId]: {
              Parameter: kra.kratitle,
              Weightage: parseFloat(kra.weight) || 0,
              KPIs: kpiArray,
              TotalAchievement: totalAchievement,
            },
          });
        });

        const structuredOutput = {
          kra_kpi_questions: kraKpiQuestions,
        };

        if (onDataChange) {
          onDataChange(structuredOutput);
        }
      }, 300),
    [questionSectionData, onDataChange]
  );

  const calculateScore = (weight, achievement) => {
    const numWeight = parseFloat(weight) || 0;
    return (((achievement || 0) * numWeight) / 100).toFixed(1);
  };

  // useEffect(() => {
  //     if (
  //         !getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable &&
  //         questionSectionData?.length
  //     ) {
  //         const prefilled = {};
  //         questionSectionData.forEach((kra, kraIndex) => {
  //             kra.kpis.forEach((kpi, kpiIndex) => {
  //                 const key = `${kraIndex}-${kpiIndex}`;
  //                 prefilled[key] = kpi?.achievementPercentage || 0;
  //             });
  //         });
  //         setAchievements(prefilled);
  //     }
  // }, [getKraKpiAppraisalForm, questionSectionData]);
  const isEditable =
    getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable;
  console.log(isEditable, "isEditable");

//   useEffect(() => {
//     if (
//       getKraKpiAppraisalForm?.data?.appraisal_current_status !== "not started"
//     ) {
//       console.log("hiiiii");

//       const initialAchievements = {};
//       questionSectionData?.forEach((kra, kraIndex) => {
//         kra.kpis?.forEach((kpi, kpiIndex) => {
//           const key = `${kraIndex}-${kpiIndex}`;
//           initialAchievements[key] = kpi?.achievementPercentage || "";
//         });
//       });
//       console.log(initialAchievements, "initialAchievements");
//       setAchievements(initialAchievements);
//     }
//   }, [dispatch, getKraKpiAppraisalForm]);

useEffect(() => {
  if (questionSectionData?.length) {
    const initialAchievements = {};
    questionSectionData.forEach((kra, kraIndex) => {
      kra.kpis.forEach((kpi, kpiIndex) => {
        const key = `${kraIndex}-${kpiIndex}`;
        initialAchievements[key] = kpi?.achievementPercentage ?? 0; // ensure number
      });
    });
    setAchievements(initialAchievements);
  }
}, [questionSectionData]);

  const totalSectionScores = useMemo(() => {
    return questionSectionData?.map((kra, kraIndex) => {
      let total = 0;
      kra?.kpis?.forEach((kpi, kpiIndex) => {
        const key = `${kraIndex}-${kpiIndex}`;
        const achievement = Number(achievements[key] || 0);
        const calculated = Number(calculateScore(kpi?.weight, achievement));
        total += isNaN(calculated) ? 0 : calculated;
      });
      return total.toFixed(1);
    });
  }, [achievements, questionSectionData]);

  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{ fontSize: "18px", color: "black", mb: 2 }}
        gutterBottom
      >
        KPI Appraisal Form
      </Typography>

      {questionSectionData?.map((kra, kraIndex) => {
        // let totalSectionScore = 0;

        // kra?.kpi?.forEach((kpi, kpiIndex) => {
        //     const key = `${kraIndex}-${kpiIndex}`;

        //     // Ensure achievement is a number
        //     const achievement = Number(achievements[key] || 0);

        //     console.log(achievement, "totalSectionScore11")
        //     console.log(calculateScore(kpi?.weight), "totalSectionScore11")

        //     // Ensure calculateScore returns a number
        //     const calculated = Number(calculateScore(kpi?.weight, achievement));

        //     totalSectionScore += isNaN(calculated) ? 0 : calculated;
        //     console.log(totalSectionScore, "totalSectionScore11")
        // });

        let totalSectionScore = totalSectionScores[kraIndex];
        console.log(totalSectionScore, "totalSectionScore");
        return (
          <Paper key={kra?.kraId} sx={{ p: 2, mb: 4 }} elevation={3}>
            {/* <Typography variant="h6" gutterBottom>
                        {kra.kraId}
                    </Typography> */}
            <Typography
              variant="h5"
              gutterBottom
              sx={{ color: "black", mb: 3, mt: 1 }}
            >
              {kra?.kraId}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box sx={{ display: { sm: "block", xs: "none" }, mt: 1 }}>
              <Grid container spacing={2}>
                <Grid item size={{ xs: 12, sm: 2 }}>
                  {/* <Typography variant="subtitle2" gutterBottom sx={{ color: "#514b4b" }}>
                                    Kra & Kpi Id
                                </Typography> */}
                </Grid>
                <Grid item size={{ xs: 12, sm: 4 }}>
                  {/* <Typography>Question</Typography> */}
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{ color: "#514b4b" }}
                  >
                    {/* Select KRA & KPI */}
                    Question
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 2 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{ color: "#514b4b" }}
                  >
                    Weightage (%)
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 2 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{ color: "#514b4b" }}
                  >
                    Enter Achievement %
                  </Typography>
                </Grid>
                <Grid item size={{ xs: 12, sm: 2 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{ color: "#514b4b" }}
                  >
                    Achievement Against Weightage
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ mb: 6 }}>
              <Grid container spacing={4} alignItems="center">
                <Grid size={{ xs: 12, sm: 2 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
                  >
                    {kra?.kraId}
                  </Typography>
                </Grid>

                <Grid size={{ xs: 12, sm: 4 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{
                      color: "#514b4b",
                      display: { xs: "block", sm: "none" },
                    }}
                  >
                    {/* Select KRA & KPI */}
                    Question
                  </Typography>
                  <TextField
                    // label="Parameter"
                    value={kra?.kratitle}
                    fullWidth
                    size="small"
                    disabled
                    multiline
                    rows={6}
                    sx={{ background: "#f0f0f0" }}
                  />
                </Grid>
                <Grid size={{ xs: 12, sm: 2 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{
                      color: "#514b4b",
                      display: { xs: "block", sm: "none" },
                    }}
                  >
                    {/* Select KRA & KPI */}
                    Weightage(%)
                  </Typography>
                  <TextField
                    // label="Weight (%)"
                    value={kra?.weight}
                    fullWidth
                    size="small"
                    disabled
                    sx={{
                      width: { sm: "70px", xs: "100%" },
                      background: "#f0f0f0",
                    }}
                  />
                </Grid>

                <Grid size={{ xs: 12, sm: 2 }}>
                  {/* <TextField
                                    // label="Achievement %"
                                    type="number"
                                    inputProps={{ min: 0, max: 100 }}
                                    // value={data?.selfEvaluationCompleted ? kpi?.achievementPercentage : achievement}
                                    // onChange={(e) => handleChange(kraIndex, kpiIndex, e.target.value)}
                                    size="small"
                                    fullWidth
                                    sx={{ width: {sm:"70px",xs:"100%"}, background: data?.selfEvaluationCompleted ? "#f0f0f0" : "white" }}
                                    disabled={data?.selfEvaluationCompleted}

                                /> */}
                </Grid>
                <Grid size={{ xs: 12, sm: 1 }}>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    sx={{
                      color: "#514b4b",
                      display: { xs: "block", sm: "none" },
                    }}
                  >
                    {/* Select KRA & KPI */}
                    Achievement Against Weightage
                  </Typography>
                  <TextField
                    // label="Weight (%)"
                    // value={data?.selfEvaluationCompleted ? kpi?.achievementWeitage : calculated}

                    // value={getKraKpiAppraisalForm?.data?.appraisal_current_status !== "not started" ? kra?.TotalAchievement : totalSectionScore}
                    // value={
                    //     getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable
                    //         ? kra?.TotalAchievement
                    //         : totalSectionScore
                    // }
                    value={
                      getKraKpiAppraisalForm?.data
                        ?.employee_appraisal_score_editable
                        ? totalSectionScore
                        : kra?.TotalAchievement
                    }
                    // value={
                    //     !hasChanged
                    //         ? kra?.TotalAchievement
                    //         : totalSectionScore > 0
                    //             ? totalSectionScore
                    //             : ""
                    // }
                    fullWidth
                    size="small"
                    disabled
                    sx={{
                      width: { sm: "70px", xs: "100%" },
                      background: "#f0f0f0",
                    }}
                  />
                  {/* <Typography>{calculated}</Typography> */}
                </Grid>
              </Grid>
            </Box>

            {kra?.kpis?.map((kpi, kpiIndex) => {
              const key = `${kraIndex}-${kpiIndex}`;
              const achievement = achievements[key] || "";
              console.log(achievement, "achievement");
              const calculated = calculateScore(kpi?.weight, achievement);
              totalSectionScore += isNaN(calculated) ? 0 : calculated;
              console.log(totalSectionScore, "totalSectionScore");

              return (
                <Box key={kpi?.kpiId} sx={{ mb: 6 }}>
                  <Grid container spacing={4} alignItems="center">
                    <Grid size={{ xs: 12, sm: 2 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
                      >
                        {kpi?.kpiId}
                      </Typography>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 4 }}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{
                          color: "#514b4b",
                          display: { xs: "block", sm: "none" },
                        }}
                      >
                        {/* Select KRA & KPI */}
                        Question
                      </Typography>
                      <TextField
                        // label="Parameter"
                        value={kpi?.parameter}
                        fullWidth
                        size="small"
                        disabled
                        multiline
                        rows={6}
                        sx={{ background: "#f0f0f0" }}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 2 }}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{
                          color: "#514b4b",
                          display: { xs: "block", sm: "none" },
                        }}
                      >
                        {/* Select KRA & KPI */}
                        Weightage(%)
                      </Typography>
                      <TextField
                        // label="Weight (%)"
                        value={kpi?.weight}
                        fullWidth
                        size="small"
                        disabled
                        sx={{
                          width: { sm: "70px", xs: "100%" },
                          background: "#f0f0f0",
                        }}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 2 }}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{
                          color: "#514b4b",
                          display: { xs: "block", sm: "none" },
                        }}
                      >
                        {/* Select KRA & KPI */}
                        Enter Achievement % (0%-100%)
                      </Typography>
                      {/* <TextField
                                                // label="Achievement %"
                                                type="number"
                                                inputProps={{ min: 0, max: 100 }}
                                                value={getKraKpiAppraisalForm?.data?.appraisal_current_status === "not started" ? kpi?.achievementPercentage : achievement}
                                                onChange={(e) => handleChange(kraIndex, kpiIndex, e.target.value)}
                                                size="small"
                                                fullWidth
                                                sx={{ width: { sm: "70px", xs: "100%" }, background: getKraKpiAppraisalForm?.data?.appraisal_current_status === "not started" ? "#f0f0f0" : "white" }}
                                                disabled={getKraKpiAppraisalForm?.data?.appraisal_current_status === "not started"}

                                            /> */}
                      {/* <MemoizedField
                                                value={
                                                    getKraKpiAppraisalForm?.data?.appraisal_current_status !== "not started"
                                                        ? kpi?.achievementPercentage
                                                        : achievement
                                                }
                                                onChange={(e) => handleChange(kraIndex, kpiIndex, e.target.value)}
                                                disabled={
                                                    // getKraKpiAppraisalForm?.data?.appraisal_current_status !==
                                                    // "not started"
                                                    !getKraKpiAppraisalForm?.data?.employee_appraisal_score_editable
                                                }
                                            /> */}
                      <MemoizedField
                        value={achievement}
                        onChange={(e) =>
                          handleChange(kraIndex, kpiIndex, e.target.value)
                        }
                        disabled={
                          !getKraKpiAppraisalForm?.data
                            ?.employee_appraisal_score_editable
                        }
                      />

                      {/* <MemoizedField
                                                value={achievement}
                                                onChange={(e) => handleChange(kraIndex, kpiIndex, e.target.value)}
                                                disabled={!isEditable}
                                            /> */}
                    </Grid>
                    <Grid size={{ xs: 12, sm: 1 }}>
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{
                          color: "#514b4b",
                          display: { xs: "block", sm: "none" },
                        }}
                      >
                        {/* Select KRA & KPI */}
                        Achievement Against Weightage
                      </Typography>
                      <TextField
                        // label="Weight (%)"
                        // value={getKraKpiAppraisalForm?.data?.appraisal_current_status !== "not started" ? kpi?.Achievement : calculated}
                        value={
                          getKraKpiAppraisalForm?.data
                            ?.employee_appraisal_score_editable && !hasChanged
                            ? kpi?.Achievement
                            : calculated
                        }
                        // value={calculated}
                        fullWidth
                        size="small"
                        disabled
                        sx={{
                          width: { sm: "70px", xs: "100%" },
                          background: "#f0f0f0",
                        }}
                      />
                      {/* <Typography>{calculated}</Typography> */}
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
          </Paper>
        );
      })}
    </Box>
  );
};

export default AppraisalFormComponent;
